import { format, fromUnixTime } from "date-fns";
import React, { Component, Fragment } from "react";
import {
  FaHeadset,
  FaRegAngry,
  FaRegBuilding,
  FaRegCalendarAlt,
  FaRegCommentDots,
  FaRegFolderOpen,
  FaRegUser,
} from "react-icons/fa";
import { FiPieChart } from "react-icons/fi";
import { MdArrowBack, MdEdit } from "react-icons/md";
import { connect } from "react-redux";
import {
  firebaseConnect,
  firestoreConnect,
  isLoaded,
  withFirestore,
} from "react-redux-firebase";
import { Link } from "react-router-dom";
import { compose } from "recompose";
import { reduxForm } from "redux-form";
import {
  Button,
  Card,
  CardHeader,
  Col,
  Container,
  ListGroup,
  ListGroupItem,
  Row,
} from "shards-react";
import LoadingComponent from "../../../../common/loading/LoadingComponent";
import { closeModal, openModal } from "../../../../common/modals/modalActions";
import { deleteItem } from "../../../Admin/adminActions";
import Emails from "../../Emails/Emails";
import {
  addAgent,
  updateComplaint,
  updateComplaintArray,
  updateSector,
} from "../complaintActions";

import { storage } from "firebase/app";
import { getLatestFileUrl } from "../../../../common/util/getLatestFileUrl";

const mapState = (state, ownProps) => {
  const complaintId = ownProps.match.params.id;
  const profile = state.firebase.profile;
  const firestore = state.firestore;
  const sectors = state.firebase.ordered.sectors;
  const agents = state.firestore.ordered.agents;
  const categories = state.firebase.ordered.categories;
  const subcategories = state.firebase.ordered.subcategories;
  const documents = state.firestore.ordered.documents;
  const complaintTypes = state.firebase.ordered.complaintTypes;
  const users = state.firestore.data.users;

  //Get Complaints

  let complaint = firestore.data.complaint;

  return {
    complaint,
    users,
    profile,
    sectors,
    categories,
    subcategories,
    agents,
    complaintTypes,
    documents,
    complaintId,
  };
};

const actions = {
  openModal,
  closeModal,
  updateComplaint,
  updateSector,
  addAgent,
  deleteItem,
  updateComplaintArray,
};

export class ComplaintDetails extends Component {
  state = {
    toggleEditor: false,
    complainant: "",
    sector: "",
    category: "",
    subcategory: "",
    subcategories: [],
    complainantError: "",
    toggleSectorEdit: false,
    toggleAgentEdit: false,
    agent: {
      displayName: "",
      role: "",
      uid: "",
    },
  };

  componentDidUpdate() {
    if (this.state.toggleEditor) {
      this.props.openModal("EmailModal", {
        complaint: this.props.complaint,
        complaintId: this.props.complaint.id,
        closeMo: this.closeMo,
      });
    }
  }

  checkStatus = (status) => {
    switch (status) {
      case "open":
        return <div className="pill w-50  ticket-open caption">Open</div>;

      case "processing":
        return (
          <div className="pill w-50  ticket-processing caption">Processing</div>
        );

      case "closed":
        return <div className="pill w-50  ticket-closed caption">Closed</div>;

      case "cancelled":
        return <div className="pill w-50  ticket-closed caption">Cancelled</div>;

      case "overdue":
        return <div className="pill w-50  ticket-overdue caption">Overdue</div>;

      default:
        return <div className="pill w-50  ticket-open caption">Open</div>;
    }
  };

  handleReOpenComplaint = (complaint) => {
    let newComplaint = { ...complaint };

    //Change status from processing to closed
    newComplaint.status = "processing";

    // Update complaint with the updates
    this.props.updateComplaint(newComplaint);
    this.props.closeModal();
  };

  getComplainant = (complaint) => {
    if (complaint) {
      this.props.firestore
        .get(`users/${complaint.complainant.uid}`)
        .then((data) => {
          if (this.props.users && this.props.users[complaint.complainant.uid]) {
            console.log("trigger1");
            this.setState({
              complainant: this.props.users[complaint.complainant.uid],
            });
          } else {
            console.log("trigger2");
            this.setState({
              complainantError: "Complainant profile not found",
            });
          }
        })
        .catch((err) => {
          console.error(err);
          this.setState({
            complainantError: "Complainant profile not found",
          });
        });
    }
  };
  render() {
    const { complainant, complainantError } = this.state;
    const { complaint, history, profile, complaintId, documents } = this.props;

    if (!isLoaded(complaint) || !complaint)
      return <LoadingComponent loading={true} />;

    return (
      <Fragment>
        <Container>
          {complaint && (
            <Card small className="my-2">
              <CardHeader className="border-bottom d-flex justify-content-between bg-primary">
                <Button
                  as={Link}
                  onClick={() => history.goBack()}
                  className="text-white float-left btn-transparent"
                >
                  <MdArrowBack className="text-white" /> Back
                </Button>
                <h5 className="m-0 float-left">Complaint Details</h5>
                {complaint && complaint.status !== "closed" ? (
                  <Button
                    className="btn-primary"
                    onClick={() =>
                      history.push(`/dashboard/manage/${complaint.id}`)
                    }
                  >
                    <MdEdit className="mr-1" />
                    Edit Complaint
                  </Button>
                ) : (
                  <div />
                )}
              </CardHeader>

              <ListGroup>
                <ListGroupItem>
                  <strong>Ticket Details</strong>
                  <Row>
                    <Col md="12" lg="3">
                      <FaRegFolderOpen className="text-primary" />
                      <strong>Case Id</strong>
                      <div>{complaint.id}</div>
                    </Col>
                    <Col md="12" lg="3">
                      <FaRegCalendarAlt className="text-primary" />
                      <strong>Date</strong>
                      <div>
                        {complaint.created && complaint.created._seconds
                          ? fromUnixTime(
                              complaint.created._seconds
                            ).toDateString()
                          : format(complaint.created.toDate(), "dd MMM yyyy")}
                      </div>
                    </Col>
                    <Col md="12" lg="3">
                      <FaRegAngry className="text-primary mr-1" />
                      <strong>Complaint Type</strong>
                      {complaint.complaintType ? (
                        <div className="text-capitalize">
                          {complaint.complaintType}
                        </div>
                      ) : (
                        <div>Not Assigned</div>
                      )}
                    </Col>
                    <Col md="12" lg="3">
                      <FaRegAngry className="text-primary mr-1" />
                      <strong>Status</strong>

                      <span className="pill">
                        {this.checkStatus(complaint.status)}
                      </span>
                    </Col>
                  </Row>
                </ListGroupItem>
                <ListGroupItem>
                  <FiPieChart className="mr-1 text-primary" />
                  <strong>Sector</strong>

                  {/* {profile.role === 'manager' ? (
										<Button
											className={
												'float-right ' + (toggleSectorEdit ? 'btn-danger' : 'btn-primary')
											}
											onClick={() => this.setState({ toggleSectorEdit: !toggleSectorEdit })}
										>
											{toggleSectorEdit ? 'Close' : 'Edit Sector'}
										</Button>
									) : (
										''
									)} */}
                  {complaint.sectors && complaint.sectors.length > 0 ? (
                    window.innerWidth >= 480 ? (
                      <Fragment>
                        <table className="table mb-0">
                          <thead className="bg-light">
                            <tr>
                              <th scope="col" className="border-0 ">
                                Sectors
                              </th>
                              <th scope="col" className="border-0">
                                Categories
                              </th>
                              <th scope="col" className="border-0">
                                Subcategories
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                {complaint.sectors &&
                                  complaint.sectors.map((sector, index) => (
                                    <div
                                      className="text-dark text-capitalize"
                                      key={index}
                                    >
                                      {sector}
                                    </div>
                                  ))}
                              </td>
                              <td>
                                {complaint.categories &&
                                  complaint.categories.map(
                                    (category, index) => (
                                      <div
                                        className="text-dark text-capitalize"
                                        key={index}
                                      >
                                        {category}
                                      </div>
                                    )
                                  )}
                              </td>
                              <td>
                                {complaint.subcategories &&
                                  complaint.subcategories.map(
                                    (subcategory, index) => (
                                      <div
                                        className="text-dark text-capitalize"
                                        key={index}
                                      >
                                        {subcategory}
                                      </div>
                                    )
                                  )}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </Fragment>
                    ) : (
                      <Fragment>
                        <div>
                          <strong>Sector</strong>
                          {complaint.sectors &&
                            complaint.sectors.map((sector, index) => (
                              <div
                                className="text-dark text-capitalize"
                                key={index}
                              >
                                {sector}
                              </div>
                            ))}
                        </div>
                        <div>
                          <strong>Category</strong>
                          {complaint.categories &&
                            complaint.categories.map((category, index) => (
                              <div
                                className="text-dark text-capitalize"
                                key={index}
                              >
                                {category}
                              </div>
                            ))}
                        </div>
                        <div>
                          <strong>Subcategory</strong>
                          {complaint.subcategories &&
                            complaint.subcategories.map(
                              (subcategory, index) => (
                                <div
                                  className="text-dark text-capitalize"
                                  key={index}
                                >
                                  {subcategory}
                                </div>
                              )
                            )}
                        </div>
                      </Fragment>
                    )
                  ) : (
                    <div>Sector not assigned</div>
                  )}
                </ListGroupItem>
                {/* // Show Agent details on to agent and manager */}
                {profile.role === "complainant" ? (
                  ""
                ) : (
                  <ListGroupItem>
                    <FaHeadset className="mr-1 text-primary" />
                    <strong>Agent</strong>

                    {complaint && complaint.agent.displayName !== "" ? (
                      <Fragment>
                        <div className="mt-1 text-capitalize">
                          Name : {complaint.agent.displayName}
                        </div>
                      </Fragment>
                    ) : (
                      <div> Agent not assigned</div>
                    )}
                  </ListGroupItem>
                )}
                <ListGroupItem>
                  <FaRegUser className="mr-1 text-primary" />
                  <strong>Complainant</strong>
                  <Row>
                    <Col lg="4" md="6">
                      Name : {complaint.createdBy}
                    </Col>
                    <Col lg="4" md="6">
                      Email: {complaint.complainant.email}
                    </Col>

                    {complainant && complainant !== "" ? (
                      <Fragment>
                        <Col lg="4" md="6" className="mt-1 text-capitalize">
                          National ID: {complainant.userNationalId}
                        </Col>
                        <Col lg="4" md="6" className="mt-1 text-capitalize">
                          Nationality: {complainant.userCitizenship}
                        </Col>
                        <Col lg="4" md="6" className="mt-1 text-capitalize">
                          Gender: {complainant.userGender}
                        </Col>

                        <Col lg="4" md="6" className="mt-1 text-capitalize">
                          Contact: {complainant.userMobile}
                        </Col>

                        <Col lg="4" md="6" className="mt-1 text-capitalize">
                          Address: {complainant.userAddress1},
                          {complainant.userAddress2},
                          {complainant.userAddressTown},
                          {complainant.userAddressPostCode},
                          {complainant.userAddressState}, Malaysia
                        </Col>
                      </Fragment>
                    ) : (
                      ""
                    )}
                  </Row>
                  {complainantError && complainantError !== "" ? (
                    <div className="text-danger">{complainantError}</div>
                  ) : (
                    ""
                  )}

                  {profile.role === "agent" ||
                  profile.role === "temp-agent" ||
                  profile.role === "manager" ? (
                    <Button
                      onClick={() => this.getComplainant(complaint)}
                      className="mt-2"
                      disabled={complainant !== ""}
                    >
                      Lookup Complainant
                    </Button>
                  ) : (
                    ""
                  )}
                </ListGroupItem>
                <ListGroupItem>
                  <FaRegBuilding className="mr-1 text-primary" />
                  <strong>Company Details</strong>
                  <Row>
                    <Col>
                      <strong>Company Name </strong>: {complaint.companyName}
                    </Col>
                    <Col>
                      <strong>Company Email</strong>: {complaint.companyEmail}
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <strong>Location </strong>: {complaint.companyAddress1},
                      {complaint.companyAddress2},{complaint.companyAddressTown}
                    </Col>
                    <Col md="6">
                      <strong>Contact Number</strong>: {complaint.companyTel}
                    </Col>
                  </Row>
                  <Row></Row>
                </ListGroupItem>
                <ListGroupItem>
                  <FaRegCommentDots className="mr-1 text-primary" />
                  <strong>Details</strong>
                  <Row>
                    <Col>
                      Complaint :
                      <div className="details">
                        {complaint.complaintDetails}
                      </div>
                    </Col>
                  </Row>
                </ListGroupItem>
                {complaint.documents && complaint.documents.length > 0 ? (
                  <ListGroupItem>
                    <strong>Attachments</strong>
                    {complaint.documents.map((document) => {
                      return (
                        <div key={document.fileName}>
                          <a
                            className="text-primary custom-link"
                            onClick={() =>
                              getLatestFileUrl(
                                complaint.id,
                                document,
                                "documents"
                              )
                            }
                          >
                            {document.fileName}
                          </a>
                        </div>
                      );
                    })}
                  </ListGroupItem>
                ) : (
                  ""
                )}
                {profile.role === "agent" ||
                profile.role === "temp-agent" ||
                profile.role === "manager" ? (
                  <ListGroupItem>
                    {complaint.notes && complaint.notes.length > 0 ? (
                      <Fragment>
                        <strong>Notes</strong>
                        {complaint.notes.map((note, index) => (
                          <div className="d-flex" key={index}>
                            {note.date && note.date}:
                            <div className="titleCase ml-1">{note.message}</div>
                          </div>
                        ))}
                      </Fragment>
                    ) : (
                      ""
                    )}
                  </ListGroupItem>
                ) : (
                  ""
                )}

                {profile.role === "manager" ||
                profile.role === "agent" ||
                profile.role === "temp-agent" ? (
                  <ListGroupItem>
                    {complaint.status === "closed" ? (
                      <Button
                        className="mt-2 text-white float-left"
                        onClick={() => {
                          this.props.openModal("ReOpenComplaint", {
                            closeModal: this.props.closeModal,
                            complaint: complaint,
                            handleChange: this.handleChange,
                            handleReOpenComplaint: this.handleReOpenComplaint,
                          });
                        }}
                        theme="danger"
                      >
                        ReOpen Case
                      </Button>
                    ) : (
                      ""
                    )}
                  </ListGroupItem>
                ) : (
                  ""
                )}
              </ListGroup>
            </Card>
          )}
        </Container>

        <Emails
          complaint={complaint}
          complaintId={complaintId}
          profile={profile}
        />
      </Fragment>
    );
  }
}

export default compose(
  connect(mapState, actions),
  firebaseConnect((props) => {
    if (props.profile.role === "manager" || props.profile.role === "agent") {
      return [
        { path: "/sectors", queryParams: ["orderByValue"], storeAs: "sectors" },
        {
          path: "/categories",
          queryParams: ["orderByValue"],
          storeAs: "categories",
        },
        {
          path: "/subcategories",
          queryParams: ["orderByValue"],
          storeAs: "subcategories",
        },
      ];
    }
    if (props.profile.role === "agent") {
      return [
        {
          path: "/complaintTypes",
          queryParams: ["orderByValue"],
          storeAs: "complaintTypes",
        },
      ];
    } else {
      return [];
    }
  }),
  firestoreConnect((props) => [
    {
      collection: "complaints",
      doc: props.complaintId,
      storeAs: "complaint",
    },
  ]),
  withFirestore,
  //firestoreConnect,
  //firestoreConnect((props) => [ { collection: 'sectors', doc: props.sector, storeAs: 'querySectorDoc' } ]),
  reduxForm({ form: "sectorForm" })
)(ComplaintDetails);
